import commaNumber from "comma-number";

class DataFormatting {
  static formatCellValue(value, decimalPlaces, units) {
    let formattedValue = value;

    if (value == null) return value;

    if (units === "%") {
      formattedValue = value * 100;
    }

    if (typeof decimalPlaces === "number") {
      if (decimalPlaces === 0) formattedValue = Math.round(formattedValue);
      else formattedValue = parseFloat(formattedValue).toFixed(decimalPlaces);
    } else {
      console.error(
        `No or invalid decimalPlaces supplied, expects a number. ${decimalPlaces}`
      );
    }

    //comma separated
    formattedValue = commaNumber(formattedValue);
    //console.log('formatted value', value, formattedValue, variable);
    return formattedValue;
  }
}

export default DataFormatting;



// WEBPACK FOOTER //
// ./src/utils/data_formatting/dataFormatting.js